import React from "react";
import { getFirestore, collection, getDocs } from "firebase/firestore";
import themeLarge from "../../ThemeLarge";
import ProjectUrlView from "../ProjectUrl";
import KeywordView from "../Keywords";
import Footer from "../../Footer";

class ProjectDetailsMobile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      project: null,
      loading: true,
    };
  }

  isCacheExpired = (timestamp) => {
    const now = new Date();
    const cacheTime = new Date(timestamp);
    const diffInDays = (now - cacheTime) / (1000 * 60 * 60 * 24);
    return diffInDays > 30;
  };

  async componentDidMount() {
    const { slug } = this.props;

    const cacheKey = "projects_cache";
    const timestampKey = "projects_cache_time";
    const cachedData = localStorage.getItem(cacheKey);
    const cachedTime = localStorage.getItem(timestampKey);

    let projects = [];

    if (cachedData && cachedTime && !this.isCacheExpired(cachedTime)) {
      projects = JSON.parse(cachedData);
    } else {
      const db = getFirestore();
      const querySnapshot = await getDocs(collection(db, "projects"));
      projects = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      localStorage.setItem(cacheKey, JSON.stringify(projects));
      localStorage.setItem(timestampKey, new Date().toISOString());
    }

    // Find project by slug (or id if you're using that)
    const project = projects.find((p) => p.slug === slug || p.id === slug);

    this.setState({ project, loading: false });
  }

  render() {
    const { project, loading } = this.state;
    const { slug } = this.props;

    if (loading) return <p>Loading project...</p>;

    if (!project)
      return (
        <>
          <div
            className="col-md-12"
            style={{
              height: "100vh",
              background: themeLarge.colors.bg,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <p
              style={{
                fontSize: themeLarge.fontSize.display,
                color: themeLarge.colors.primary,
                marginBottom: "20px",
              }}
            >
              404!
            </p>

            <p
              style={{
                fontSize: themeLarge.fontSize.h1,
                textAlign: "center",
                paddingLeft: "10px",
              }}
            >
              Project
            </p>

            <p
              style={{
                fontSize: themeLarge.fontSize.h1,
                color: themeLarge.colors.text,
                fontWeight: 600,
                textDecoration: "underline",
                textAlign: "center",
              }}
            >
              {slug}
            </p>

            <p
              style={{
                fontSize: themeLarge.fontSize.h1,
                textAlign: "center",
              }}
            >
              not found!
            </p>
          </div>

          <Footer />
        </>
      );

    return (
      <>
        <div
          style={{
            padding: "20px",
            fontFamily: "Kumbh Sans",
            background: themeLarge.colors.bg,
          }}
        >
          <p
            style={{
              fontSize: themeLarge.fontSize.h1,
              color: themeLarge.colors.text,
            }}
          >
            {project.name}
          </p>
          <p
            style={{ fontSize: themeLarge.fontSize.body, textAlign: "justify" }}
          >
            {project.description}
          </p>

          <>
            <div
              style={{
                paddingTop: "5px",
              }}
            >
              {project.github !== "" ? (
                <ProjectUrlView
                  url={project.github}
                  title="GitHub"
                ></ProjectUrlView>
              ) : null}
              {project.deploy !== "" ? (
                <ProjectUrlView
                  url={project.deploy}
                  title="Deploy"
                ></ProjectUrlView>
              ) : null}

              {project.blog !== "" ? (
                <ProjectUrlView
                  url={project.blog}
                  title="Write-up/Blog"
                ></ProjectUrlView>
              ) : null}
            </div>
          </>

          <p
            className=""
            style={{
              fontSize: themeLarge.fontSize.body,
              fontWeight: 500,
              paddingTop: "5px",
            }}
          >
            {" "}
            Keywords
          </p>

          {/* keywords here */}
          <div
            className="row"
            style={{
              paddingBottom: "5px",
            }}
          >
            {project.keywords.map((word, index) => (
              <KeywordView key={index} keyword={word} />
            ))}
          </div>
        </div>

        <Footer />
      </>
    );
  }
}

export default ProjectDetailsMobile;
